module.exports = __webpack_public_path__ + "img/yyhb-img1-6.51f4a33f.png";